import { writable } from 'svelte/store';
function createChatWidgetStore() {
    const { subscribe, update, set } = writable({
        isHidden: true,
        isFirstTimeOpen: undefined,
    });
    /** Helper to calculate the new isFirstTimeOpen state */
    function decideIsFirstTimeOpen(currentIsFirstTimeOpen, newIsHidden) {
        let newIsFirstTimeOpen = currentIsFirstTimeOpen;
        // Set to true on first open
        if (currentIsFirstTimeOpen === undefined && !newIsHidden) {
            newIsFirstTimeOpen = true;
        }
        // Set to false after first close
        if (currentIsFirstTimeOpen === true && newIsHidden) {
            newIsFirstTimeOpen = false;
        }
        // newIsFirstTimeOpen stays false if it is already false
        return newIsFirstTimeOpen;
    }
    function toggle() {
        update((state) => {
            const newIsHidden = !state.isHidden;
            return {
                isHidden: newIsHidden,
                isFirstTimeOpen: decideIsFirstTimeOpen(state.isFirstTimeOpen, newIsHidden),
            };
        });
    }
    function hide() {
        update((state) => ({
            isHidden: true,
            isFirstTimeOpen: decideIsFirstTimeOpen(state.isFirstTimeOpen, true),
        }));
    }
    function show() {
        update((state) => ({
            isHidden: false,
            isFirstTimeOpen: decideIsFirstTimeOpen(state.isFirstTimeOpen, false),
        }));
    }
    function reset() {
        set({
            isHidden: true,
            isFirstTimeOpen: undefined,
        });
    }
    return {
        subscribe,
        toggle,
        hide,
        show,
        reset,
    };
}
/**
 * Global store for managing the Ask Square chat widget state. This store is exposed in the public-web-nav package for
 * external access.
 *
 * Available methods:
 *
 * - `toggle()`: Toggle the chat widget visibility
 * - `show()`: Show the chat widget
 * - `hide()`: Hide the chat widget
 * - `reset()`: Reset to initial state (for testing)
 *
 * @example
 *   ```typescript
 *   import { chatWidgetStore } from '@squareup/public-web-nav';
 *
 *   // Show the chat widget programmatically
 *   chatWidgetStore.show();
 *
 *   // Subscribe to state changes
 *   chatWidgetStore.subscribe(state => {
 *     console.log('Widget is hidden:', state.isHidden);
 *   });
 *   ```;
 */
export const chatWidgetStore = createChatWidgetStore();
